import React from 'react';
import { Button } from './button';

export const AboutFranchiseSection = () => {
  return (
    <section id="about" className="py-24 bg-cream">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="section-title text-5xl md:text-6xl font-bold mb-12 text-dark">
            About the Franchise Opportunity
          </h2>
          
          <div className="bg-white rounded-3xl p-12 shadow-xl border">
            <p className="text-lg md:text-xl text-subtle leading-relaxed mb-8">
              Need A Hair Makeover is an award-winning specialist salon franchise focusing on hair extensions, 
              hair loss treatments, and bespoke hair solutions. We work with celebrities, serve the entertainment 
              industry (TV, film, theatre), and cater to premium clients for special occasions.
            </p>
            
            <p className="text-lg md:text-xl text-subtle leading-relaxed mb-8">
              Our franchise owners benefit from training in 18 different hair extension techniques, 
              comprehensive business support, insurance claims expertise, and access to our established 
              client base including celebrity clientele.
            </p>
            
            <div className="grid md:grid-cols-2 gap-8 mb-8">
              <div className="bg-accent-primary/5 rounded-2xl p-6 border border-accent-primary/20">
                <h3 className="font-bold text-accent-primary mb-3">🎭 Premium Services</h3>
                <ul className="text-left text-subtle space-y-2">
                  <li>• Hair Extensions (18 techniques)</li>
                  <li>• Hair Loss Treatments</li>
                  <li>• Bespoke Handmade Wigs</li>
                  <li>• Toppers & Toupees</li>
                </ul>
              </div>
              
              <div className="bg-accent-primary/5 rounded-2xl p-6 border border-accent-primary/20">
                <h3 className="font-bold text-accent-primary mb-3">🌟 Target Market</h3>
                <ul className="text-left text-subtle space-y-2">
                  <li>• Celebrities & VIP Clients</li>
                  <li>• Weddings & Special Events</li>
                  <li>• TV, Film & Theatre</li>
                  <li>• Medical Hair Loss Cases</li>
                </ul>
              </div>
            </div>
            
            {/* Award Winning Excellence with Video */}
            <div className="bg-accent-primary/10 rounded-2xl p-8 border border-accent-primary/20 mb-8">
              <p className="text-accent-primary font-semibold text-lg mb-4 text-center">
                🏆 Award-Winning Excellence
              </p>
              <p className="text-subtle mb-6 text-center">
                Join our established network with proven success in the premium hair and beauty market across the UK.
              </p>
              
              {/* YouTube Shorts Video */}
              <div className="mb-6">
                <div className="aspect-[9/16] max-w-sm mx-auto rounded-2xl overflow-hidden shadow-lg border-4 border-accent-primary/20">
                  <iframe
                    src="https://www.youtube.com/embed/E2_xC_wGwu0"
                    title="Need A Hair Makeover - Award Winning Excellence"
                    className="w-full h-full"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
                <p className="text-center text-sm text-subtle mt-3">
                  Watch our award-winning work in action
                </p>
              </div>
              
              {/* Franchise Association Accreditation */}
              <div className="bg-white rounded-lg p-4 border border-accent-primary/20">
                <div className="flex items-center justify-center space-x-4">
                  <div className="text-center">
                    <div className="bg-accent-primary/10 rounded-full p-3 w-16 h-16 flex items-center justify-center mx-auto mb-2">
                      <span className="text-2xl">🏅</span>
                    </div>
                    <p className="text-sm font-semibold text-dark">Accredited Member</p>
                    <p className="text-xs text-subtle">Franchise Association</p>
                  </div>
                  <div className="text-left flex-1">
                    <p className="text-sm font-medium text-dark mb-1">
                      Officially registered and accredited with the Franchise Association UK
                    </p>
                    <a 
                      href="https://www.franchise-association.org.uk/faouk_directory/need-a-hair-makeover-franchise/" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-xs text-accent-primary hover:underline"
                    >
                      View our accreditation →
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};